<template>
  <div class="login">
    <h2>Log In</h2>
    <form method="post" @submit.prevent="login" name="login">
      <vuestic-alert type="danger" v-if="error">
        <span class="badge badge-pill badge-danger">Error</span>
        {{ errorMessage }}
      </vuestic-alert>
      <div class="form-group form-group-auth">
        <div class="input-group">
          <input type="text" v-model="username" id="username" required="required"/>
          <label class="control-label" for="username">{{'Username' | translate}}</label><i class="bar"></i>
        </div>
      </div>
      <div class="form-group form-group-auth">
        <div class="input-group password-input-group">
          <input 
            :type="showPassword ? 'text' : 'password'" 
            v-model="password" 
            id="password" 
            required="required"
          />
          <label class="control-label" for="password">{{'auth.password' | translate}}</label>
          <i class="bar"></i>
          <span class="password-toggle" @click="togglePassword">
            <i :class="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between down-container">
        <button class="btn btn-primary" type="submit">
          {{'auth.login' | translate}}
        </button>
        <router-link :to="{name: 'ForgotPassword'}">Forgot Password?</router-link>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios'
  import jwtDecode from 'jwt-decode'
  import store from '../../../store'
  
  export default {
    name: 'login',
    data: function () {
      return {
        username: '',
        password: '',
        showPassword: false,
        error: false,
        errorMessage: 'Login Failed!',
        // brandingLogo: localStorage.getItem('branding-logo'),
        // brandingColor: localStorage.getItem('branding-color'),
        brandingName: localStorage.getItem('branding-name') || 'FracTEL'
      }
    },
    methods: {
      togglePassword () {
        this.showPassword = !this.showPassword
      },
      validateEmail (email) {
        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      },
      login: async function () {
        try {
          store.commit('setLoading', true)
          const { username, password } = this

          this.error = false
          if (this.validateEmail(username)) {
            // FoneStorm API Authentication
            let resp = await axios({ url: `${process.env.FoneStorm_API}/auth`, data: { username, password, expires: 86400 }, method: 'POST' })
            const token = resp.data.auth.token
            const decoded = await jwtDecode(token)
            const accountId = decoded.account.id
            localStorage.setItem('fonestorm-token', token) // store the token in localstorage
            localStorage.setItem('fonestorm-username', username) // store the token in localstorage
            localStorage.setItem('fonestorm-account', accountId) // store the token in localstorage
            localStorage.setItem('fonestorm-parent-token', token) // store the token in localstorage
            localStorage.setItem('fonestorm-parent-username', username) // store the token in localstorage
            localStorage.setItem('fonestorm-parent-account', accountId) // store the token in localstorage

            // Account Info
            let accountInfo = await axios.get(`${process.env.FoneStorm_API}/accounts/info`, { headers: { token } })
            localStorage.setItem('fonestorm-billing-account', accountInfo.data.account.billing_id) // store the token in localstorage
            localStorage.setItem('fonestorm-billing-plan', accountInfo.data.account.plan) // store the plan in localstorage
            localStorage.setItem('fonestorm-account-name', accountInfo.data.account.label) // store the token in localstorage

            // SmartOffice API Authentication
            try {
              let response = await axios({ url: `https://${accountId}.${process.env.Flow_URL}/auth/token`, header: { 'Node-RED-API-Version': 'v2', 'Content-Type': 'application/json' }, data: { username, password, scope: '', grant_type: 'password', client_id: 'node-red-editor' }, method: 'POST' })
              const flowToken = response.data.token_type + ' ' + response.data.access_token
              localStorage.setItem('flow-token', flowToken) // store the token in localstorage
              localStorage.setItem('flow-login-token', response.data.access_token) // store the token in localstorage
            } catch (error) {
              // Do Nothing
            }
            store.commit('setLoading', false)
            this.$router.push(this.$route.query.redirect || '/home')
          } else {
            store.commit('setLoading', false)
            this.error = true
            this.errorMessage = 'Please enter a valid email address.'
          }
        } catch (error) {
          console.log(error)
          localStorage.removeItem('fonestorm-token') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('fonestorm-username') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('fonestorm-account') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('fonestorm-parent-token') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('fonestorm-parent-username') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('fonestorm-parent-account') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('flow-token') // if the request fails, remove any possible user token if possible
          localStorage.removeItem('flow-login-token') // if the request fails, remove any possible user token if possible
          store.commit('setLoading', false)
          this.error = true
          this.errorMessage = 'Login Failed!'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../sass/variables';
  @import '~bootstrap/scss/mixins/breakpoints';
  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';
  
  .login {
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
    }
    width: 21.375rem;

    .down-container {
      margin-top: 3.125rem;
    }
    
    .form-group-auth {
      margin-top: 0.2rem;
      margin-bottom: 2.25rem;
    }

    .password-input-group {
      position: relative;
      
      .password-toggle {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        z-index: 10;
        color: var(--brand-primary, #{$fractel-teal});
        font-size: 1.1rem;
        padding: 5px;
        transition: color 0.3s ease;
        
        &:hover {
          color: var(--brand-dark, #{$fractel-dark-teal});
        }
        
        i {
          pointer-events: none;
        }
      }
      
      // Adjust input padding to make room for the eye icon
      input[type="password"],
      input[type="text"] {
        padding-right: 40px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/login/Login.vue